import React, { useMemo } from 'react';
import { useLanguage } from '../../../../../LanguageProvider';
import Services from '../../../../../services/Services';
import SHCommentBox from '../../../components/SHCommentBox/SHCommentBox';

const SHEventCommentBox = ({ comments = [], event }) => {
    const { getTranslation } = useLanguage();
    const token = useMemo(() => localStorage.getItem('token'), []);

    const handleCommentSubmit = (text) => {
        return Services.SocialHiveCommentOnEvent(
            token,
            event?.channelID,
            event?.eventID,
            text
        );
    };

    return (
        <SHCommentBox
            comments={comments}
            onCommentSubmit={handleCommentSubmit}
            enableLikes={false}
            placeholder={getTranslation('writeSomethingAboutTheEvent')}
        />
    );
};

export default SHEventCommentBox;